import { ApolloLink } from '@apollo/client';
import { DefinitionNode, VariableDefinitionNode, TypeNode } from 'graphql';
// Generated map
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import localDateInputMap from '@/generated/localDateInputMap.json';

export type LocalDateDescriptor =
  | { kind: 'scalar'; name: string }
  | { kind: 'input'; name: string }
  | { kind: 'list'; ofType: LocalDateDescriptor };
export type LocalDateMap = {
  inputTypes: Record<string, Record<string, LocalDateDescriptor>>;
};

export const ldMap = localDateInputMap as unknown as LocalDateMap;

export function formatDateYYYYMMDD(date: Date): string {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, '0');
  const d = String(date.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
}

export function transformLeafLocalDate(value: any): any {
  if (value instanceof Date) return formatDateYYYYMMDD(value);
  if (typeof value === 'number') return formatDateYYYYMMDD(new Date(value));
  if (typeof value === 'string') {
    if (/^\d{4}-\d{2}-\d{2}$/.test(value)) return value;
    if (/^\d{4}-\d{2}-\d{2}T/.test(value)) return value.slice(0, 10);
  }
  return value;
}

export function transformByDescriptor(
  value: any,
  desc: LocalDateDescriptor,
  map: LocalDateMap = ldMap
): any {
  if (!desc) return value;
  if (desc.kind === 'list') {
    if (!Array.isArray(value)) return value;
    return value.map((v) => transformByDescriptor(v, desc.ofType, map));
  }
  if (desc.kind === 'input') {
    const def = map.inputTypes[desc.name];
    if (!def || value == null || typeof value !== 'object') return value;
    const result = { ...value };
    for (const key of Object.keys(def)) {
      if (!(key in result)) continue;
      result[key] = transformByDescriptor(
        result[key],
        def[key] as LocalDateDescriptor,
        map
      );
    }
    return result;
  }
  if (desc.kind === 'scalar') {
    if (desc.name === 'LocalDate') return transformLeafLocalDate(value);
    return value;
  }
  return value;
}

export function buildDescriptorFromTypeNode(
  node: TypeNode,
  map: LocalDateMap = ldMap
): LocalDateDescriptor {
  switch (node.kind) {
    case 'NonNullType':
      return buildDescriptorFromTypeNode(node.type as TypeNode, map);
    case 'ListType':
      return {
        kind: 'list',
        ofType: buildDescriptorFromTypeNode(node.type, map),
      };
    case 'NamedType': {
      const name = node.name.value;
      if (map.inputTypes[name]) return { kind: 'input', name };
      return { kind: 'scalar', name };
    }
    default:
      return { kind: 'scalar', name: 'Unknown' };
  }
}

export function createLocalDateFormattingLink(map: LocalDateMap = ldMap) {
  return new ApolloLink((operation, forward) => {
    if (!operation.variables) return forward(operation);
    try {
      const newVariables: Record<string, unknown> = { ...operation.variables };
      operation.query.definitions.forEach((def: DefinitionNode) => {
        if (def.kind !== 'OperationDefinition') return;
        (def.variableDefinitions || []).forEach(
          (vdef: VariableDefinitionNode) => {
            const varName = vdef.variable.name.value;
            const descriptor = buildDescriptorFromTypeNode(vdef.type, map);
            const value = (operation.variables as any)[varName];
            if (value == null) return;
            newVariables[varName] = transformByDescriptor(
              value,
              descriptor,
              map
            );
          }
        );
      });
      operation.variables = newVariables;
    } catch (e) {
      console.warn('[localDateFormattingLink] traversal failed', e);
    }
    return forward(operation);
  });
}

export const localDateFormattingLink = createLocalDateFormattingLink();
